import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import Select from './SelectFilter'

export const EquipmentsManufacturers = ({ equipments, onChange, values = [] }) => {
  const { t } = useTranslation()

  const choices = useMemo(() => {
    return equipments
      .reduce((acc, equipment) => {
        return acc.includes(equipment.manufacturer) ? acc : [...acc, equipment.manufacturer]
      }, [])
      .reduce((acc, manufacturer) => {
        return [
          ...acc,
          {
            label: manufacturer,
            id: manufacturer,
            value: manufacturer,
            count: equipments.filter(equipment => equipment.manufacturer === manufacturer).length
          }
        ]
      }, [])
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [equipments])

  return (
    <Select
      placeholder={t('supervision.manufacturers_placeholder')}
      selectedMessageKey={'supervision.filters.selected_manufacturers_placeholder'}
      noOptionsMessage={t('supervision.manufacturers_none')}
      options={choices}
      onChange={onChange}
      values={values}
    />
  )
}

export const EquipmentsModels = ({ equipments, onChange, values = [] }) => {
  const { t } = useTranslation()

  const choices = useMemo(() => {
    return equipments
      .reduce((acc, equipment) => {
        return acc.includes(equipment.model) ? acc : [...acc, equipment.model]
      }, [])
      .reduce((acc, model) => {
        return [
          ...acc,
          {
            label: model,
            id: model,
            value: model,
            count: equipments.filter(equipment => equipment.model === model).length
          }
        ]
      }, [])
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [equipments])

  return (
    <Select
      placeholder={t('supervision.models_placeholder')}
      selectedMessageKey={'supervision.filters.selected_models_placeholder'}
      noOptionsMessage={t('supervision.models_none')}
      options={choices}
      onChange={onChange}
      values={values}
    />
  )
}

const EquipmentsStatuses = ({ equipments, onChange, values = [] }) => {
  const { t } = useTranslation()

  const countHardwareUp = useMemo(() => {
    return equipments.filter(equipment => equipment.available_level === 'up').length
  }, [equipments])

  const countHardwareDown = useMemo(() => {
    return equipments.filter(equipment => equipment.available_level === 'down').length
  }, [equipments])

  const countHardwareHibernation = useMemo(() => {
    return equipments.filter(equipment => equipment.available_level === 'hibernation').length
  }, [equipments])

  const countHardwarePlanned = useMemo(() => {
    return equipments.filter(equipment => ['planned', 'muted'].includes(equipment.available_level)).length
  }, [equipments])

  const countHardwareWorks = useMemo(() => {
    return equipments.filter(equipment => equipment.available_level === 'works').length
  }, [equipments])

  const countHardwareSpare = useMemo(() => {
    return equipments.filter(equipment => equipment.available_level === 'spare').length
  }, [equipments])

  const countHardwareProduction = useMemo(() => {
    return equipments.filter(equipment => equipment.available_level === 'production' && equipment.manufacturer?.toLowerCase() !== 'juniper').length
  }, [equipments])
  const countHardwareJuniper = useMemo(() => {
    return equipments.filter(equipment => equipment.manufacturer.toLowerCase() === 'juniper').length
  }, [equipments])
  const choices = useMemo(() => {
    return [
      {
        label: t('supervision.status_availability.up'),
        value: 'up',
        count: countHardwareUp,
        id: 1
      },
      {
        label: t('supervision.status_availability.down'),
        value: 'down',
        count: countHardwareDown,
        id: 2
      },
      {
        label: t('supervision.status_availability.hibernation'),
        value: 'hibernation',
        count: countHardwareHibernation,
        id: 3
      },
      {
        label: t('supervision.status_availability.works'),
        value: 'works',
        count: countHardwareWorks,
        id: 4
      },
      {
        label: t('supervision.status_availability.planned'),
        value: 'planned',
        count: countHardwarePlanned,
        id: 5
      },
      {
        label: t('supervision.status_availability.spare'),
        value: 'spare',
        count: countHardwareSpare,
        id: 6
      },
      {
        label: t('supervision.status_availability.production'),
        value: 'production',
        count: countHardwareProduction,
        id: 7
      },
      {
        label: '-',
        value: 'juniper',
        count: countHardwareJuniper,
        id: 8
      }
    ]
  }, [equipments])

  const choicesFiltered = choices?.filter(choice => choice.count > 0)

  return (
    <Select
      options={choicesFiltered}
      onChange={onChange}
      mainField="label"
      placeholder={t('supervision.status_placeholder')}
      selectedMessageKey={'supervision.filters.selected_status_placeholder'}
      noOptionsMessage={t('supervision.status_availability_none')}
      values={values}
    />
  )
}

export default EquipmentsStatuses
